const ACTION_GET_LIST_SHOP = 'ACTION_GET_LIST_SHOP'
const ACTION_GET_LIST_SHOP_SUCCESS = 'ACTION_GET_LIST_SHOP_SUCCESS'

export { ACTION_GET_LIST_SHOP, ACTION_GET_LIST_SHOP_SUCCESS }
